<template>
  <section class="c-switchover-banner">
    <p>
      You can still access
      <a
        href="http://staffnet.xcmmc.nhs.uk/"
        target="_blank"
        rel="noopener nofollow"
      >Staffnet</a> and
      <a
        href="http://uhsm-intranet/AZ/Pages/default.aspx"
        target="_blank"
        rel="noopener nofollow"
      >UHSM</a>'s Intranet during the switchover period
    </p>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.c-switchover-banner {
  padding: 10px 0;
  box-sizing: border-box;
  background: $colour-nhs-orange;
  color: $colour-nhs-black;
  font-weight: bold;
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
  max-width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  display: none;

  p {
    margin: 0;
  }

  a {
    color: $colour-nhs-black;
  }

  @media screen and (min-width: 1024px) {
    display: block;
  }
}
</style>